function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 2px 5px;\n  width: fit-content;\n  border-radius: 4px;\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as Colors from '../../../utils/colors';
import { defaultTheme } from '../../../utils';
var StyledLabel = styled.div(_templateObject(), function (props) {
  return Colors[props.color][100];
}, function (props) {
  return Colors[props.color][300];
});

var Label = function Label(_ref) {
  var label = _ref.label,
      color = _ref.color,
      rest = _objectWithoutPropertiesLoose(_ref, ["label", "color"]);

  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    color: color
  }, rest), label);
};

Label.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  color: PropTypes.string.isRequired
} : {};
Label.defaultProps = {
  color: 'neutral',
  theme: defaultTheme
};
export default Label;